<template>
  <span>
    <span v-if="value === null">-</span>
    <v-chip
      v-else
      :small="true"
      :color="color"
      dark>
      <span v-if="value === true">{{ $t('new') }}</span>
      <span v-else-if="value === false">{{ $t('missing') }}</span>
      <span v-else-if="value > 0">+{{ value }}</span>
      <span v-else>{{ value }}</span>
    </v-chip>
  </span>
</template>

<script>
export default {
  name: 'PositionVariation',
  props: ['value'],
  computed: {
    color () {
      if (this.value === true) return 'success'
      else if (this.value === false) return 'error'
      else if (this.value === null) return 'grey'
      else if (this.value > 0) return 'success'
      else if (this.value < 0) return 'error'
      else return 'grey'
    },
  }
}
</script>

<i18n>
{
	"en": {
		"missing": "Gone",
		"new": "New"
	},
	"es": {
		"missing": "Desaparecido",
		"new": "Nuevo"
	},
	"fr": {
		"missing": "Disparu",
		"new": "Nouveau"
	},
	"it": {
		"missing": "Scomparso",
		"new": "Nuovo"
	},
	"pt": {
		"missing": "Desapareceu",
		"new": "Novo"
	},
	"pl": {
		"missing": "Zniknął",
		"new": "Nowy"
	}
}
</i18n>
